import * as Actions from '../actionsgazeta';

const initialState = [];

const colunistas = function (state = initialState, action) {
    switch (action.type) {
        case Actions.SET_COLUNISTAS_DATA:
            {
                return action.payload

            }
        case Actions.CLEAR_COLUNISTAS_DATA:
            {
                return state;
            }
        default:
            {
                return state
            }
    }
};

export default colunistas;
